import React from 'react';
import { useMutation } from '@apollo/client';

import ModelForm from 'components/models/ModelForm';
import { useNavigation } from 'components/navigation/hooks';
import { MUTATION_CREATE_MODEL } from 'components/models/graphql';

import validationSchema from './validationSchema';

const EXCLUDE_ON_SUBMIT = [];

const INITIAL_VALUES = {
  name: '',
  description: '',
};

const MyAccountForm = () => {
  const { navigate } = useNavigation();
  const [createModel, { loading }] = useMutation(MUTATION_CREATE_MODEL);

  const handleOnSubmit = React.useCallback(
    async input => {
      try {
        await createModel({
          variables: {
            input,
          },
        });
        navigate('/admin/autoclaves/modelos');
      } catch (err) {
        console.log('handleOnSubmit error', err);
      }
    },
    [createModel, navigate]
  );

  return (
    <ModelForm
      loading={loading}
      initialValues={INITIAL_VALUES}
      onSubmit={handleOnSubmit}
      validationSchema={validationSchema}
      excludeOnSubmit={EXCLUDE_ON_SUBMIT}
    />
  );
};

export default React.memo(MyAccountForm);
